import { Trash2 } from "lucide-react";
import LegalShell, { Section } from "@/components/LegalShell";

const STEPS = [
  "Öffne Profil.",
  "Tippe auf Konto löschen.",
  "Bestätige die Sicherheitsabfrage.",
  "Dein Konto und die zugehörigen Daten werden dauerhaft gelöscht.",
];

const REMOVED = [
  "Benutzerkonto",
  "Profilinformationen",
  "Gruppenzugehörigkeiten",
  "Chatnachrichten",
  "Aufgaben",
  "Mitbringlisten",
  "Gruppenkasse",
  "Festival Navigator (Marker und Laufwege)",
];

export default function KontoLoeschen() {
  return (
    <LegalShell testId="konto-loeschen-page" eyebrow="Konto" title="Konto löschen">
      <p>
        Du kannst dein FestivalPlan-Konto jederzeit direkt in der App löschen.
      </p>

      <Section title="So funktioniert es">
        <ol className="space-y-3">
          {STEPS.map((step, i) => (
            <li key={step} className="flex items-start gap-3">
              <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-[#8B5CF6]/20 text-xs font-semibold text-[#8B5CF6]">
                {i + 1}
              </span>
              <span>{step}</span>
            </li>
          ))}
        </ol>
      </Section>

      <Section title="Beim Löschen werden unter anderem entfernt">
        <ul className="list-disc space-y-1.5 pl-5">
          {REMOVED.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </Section>

      <div className="flex items-start gap-3 rounded-2xl border border-[#FACC15]/25 bg-[#FACC15]/10 p-5">
        <Trash2 className="mt-0.5 h-5 w-5 shrink-0 text-[#FACC15]" />
        <p className="text-sm text-white/70">
          Bestimmte Daten können aufgrund gesetzlicher Verpflichtungen für einen begrenzten Zeitraum
          aufbewahrt werden.
        </p>
      </div>

      <Section title="Fragen?">
        <p>
          Bei Fragen erreichst du uns unter:{" "}
          <a href="mailto:support@festivalplan.app" className="text-[#00E5FF]">support@festivalplan.app</a>
        </p>
      </Section>
    </LegalShell>
  );
}
